import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import { withFormik } from 'formik';
import { compose, defaultTo, path, map, sum, isEmpty } from 'ramda';

import styles from './styles.m.scss';

import { handleError, handleSuccess } from '../../../../../util/forms';
import { createMarkup, toCurrency } from '../../../../../util/helpers';
import { apiRegisterForCertification } from '../../../../../api/certification';

import FancyRadio from '../../../../../components/Forms/FancyRadio';
import Footer from '../../../../../components/Accordion/Footer';
import { apiUpdateRegistration } from '../../../../../api/registration';

const propTypes = {
  certification: PropTypes.object,
  updateRegistration: PropTypes.func,
  setStep: PropTypes.func,
  step: PropTypes.number,
};

class Pathway extends Component {
  state = {};

  renderRadioButton = (pathwayType) => {
    const { values, handleBlur, handleChange } = this.props;
    const registrationPrice = compose(
      sum(),
      map((registrationFee) => registrationFee.price),
    )(pathwayType.registrationFees);
    const years = pathwayType.deadline / 12;

    return (
      <FancyRadio
        key={'pathway-type-' + pathwayType.id}
        label={pathwayType.name}
        name="pathwayTypeId"
        value={pathwayType.id}
        checked={values.pathwayTypeId}
        onBlur={handleBlur}
        onChange={handleChange}
      >
        <p dangerouslySetInnerHTML={createMarkup(pathwayType.description)} />
        Time: up to {years} {pluralize('year', years)} from date of registration. <br />
        Registration fee: {toCurrency(registrationPrice)}
      </FancyRadio>
    );
  };

  render() {
    const { certification, handleSubmit, isSubmitting, isValid, step, setStep } = this.props;
    const pathwayTypes = defaultTo([], certification.pathwayTypes);

    if (!pathwayTypes.length) {
      return <noscript />;
    }

    const selfStudyPathways = pathwayTypes.filter(
      (pathwayType) => pathwayType.key === 'self_study' || pathwayType.key === 'chc_self_study',
    );
    const challengeBasedPathways = pathwayTypes.filter(
      (pathwayType) =>
        pathwayType.key === 'educational_challenge' ||
        pathwayType.key === 'designation_challenge' ||
        pathwayType.key === 'chc_educational_challenge' ||
        pathwayType.key === 'chc_designation_challenge',
    );
    const otherPathways = pathwayTypes.filter(
      (pathwayType) => pathwayType.key === 'university_program' || pathwayType.key === 'distance_learning_program' ||
        pathwayType.key === 'ffc_program' ||
        pathwayType.key === 'ffc_in_good_standing_program',
    );

    return (
      <form>
        <h2 className={styles.stepHeader}>
          We meet you where you are. Please select the educational pathway that fits best:
        </h2>
        {!isEmpty(selfStudyPathways) && (
          <Fragment>
            <p className="form-group-header">Self-Study Pathways</p>
            {selfStudyPathways.map((pathwayType) => this.renderRadioButton(pathwayType))}
          </Fragment>
        )}
        {!isEmpty(challengeBasedPathways) && (
          <Fragment>
            <p className="form-group-header">Challenge-Based Pathways</p>
            {challengeBasedPathways.map((pathwayType) => this.renderRadioButton(pathwayType))}
          </Fragment>
        )}
        {!isEmpty(otherPathways) && (
          <Fragment>
            <p className="form-group-header">Other Sage Financial Solutions Pathways</p>
            {otherPathways.map((pathwayType) => this.renderRadioButton(pathwayType))}
          </Fragment>
        )}
        <Footer
          step={step}
          setStep={setStep}
          isValid={isValid}
          isSubmitting={isSubmitting}
          handleSubmit={handleSubmit}
        />
      </form>
    );
  }
}

Pathway.propTypes = propTypes;

export default withFormik({
  handleSubmit: (payload, formProps) => {
    const { props } = formProps;
    const createOrUpdateRegistration = props.registration.id ? apiUpdateRegistration : apiRegisterForCertification;
    const id = defaultTo(props.certification.id, props.registration.id);

    createOrUpdateRegistration(id, { stepName: props.name, ...payload })
      .then(({ data }) => props.updateRegistration(data))
      .then(() => handleSuccess(formProps))
      .then(() => props.setStep(props.step + 1))
      .catch((err) => handleError(formProps, err));
  },
  mapPropsToValues: ({ registration }) => ({
    pathwayTypeId: defaultTo('', path(['pathwayTypeId'], registration)),
  }),
  isInitialValid: true,
  validateOnChange: true,
})(Pathway);
